<template>
	<el-main class="center-wrap orderbox">
		<div class="card-header">
				<div>
					<div class="card-title">VIP会员订单</div>
					<div class="card-desc">查看与管理您的VIP会员订单</div>
				</div>
			</div>
		<div class="orderwrap">
			<div class="ordermain">
				<div class="topbox flexBetween">
					<div class="tabtit">
						<el-link
							v-for="status in mainTradeStatusList"
							:key="status.value"
							:type="activeStatus === status.value ? 'primary' : 'text'"
							:underline="false"
							href="javascript:void(0);"
							@click.native="handleStatus(status.value)"
							>{{ status.label }}</el-link
						>
					</div>

					<div class="rightbox">
						<el-input v-model="searchParams.tradeNo" clearable placeholder="输入订单号" size="small" @keyup.enter.native="handleSearch">
							<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
						</el-input>
					</div>
				</div>
				<div v-loading="loading" element-loading-text="加载中...">
					<div v-if="orderList.length > 0">
						<div class="orderbox">
							<table class="order-tbl">
								<colgroup>
									<col class="number-col" />
									<col class="amount-col" />
									<col class="amount-col" />
									<col class="amount-col" />
									<col class="amount-col" />
								</colgroup>
								<thead class="tbl-head tc">
									<th>
										<div class="flexBetween">
											<div>
												<el-date-picker
													v-model="dataVal"
													:picker-options="pickerOptions"
													align="center"
													end-placeholder="结束日期"
													range-separator="至"
													size="small"
													start-placeholder="开始日期"
													type="daterange"
													unlink-panels
													@change="handleDateChange"
												>
												</el-date-picker>
											</div>
											<!-- <div style="text-align: center; flex: 1">订单详情</div> -->
										</div>
									</th>
									<th>商品金额</th>
									<th>订单状态</th>
									<th>发票信息</th>
									<th>订单操作</th>
								</thead>

								<tbody v-for="oinfo in orderList" :id="oinfo.id" :key="oinfo.id" class="tbl-body">
									<tr class="sep-row">
										<td colspan="5"></td>
									</tr>
									<tr class="tr-th">
										<td colspan="5">
											<div class="flexBetween">
												<div>
													<span :title="oinfo.addtime" class="dealtime">{{ oinfo.createTime }}</span>
													<span class="number"
														>订单号：<el-link style="height: 44px; color: #333333" target="neworder" type="text">{{ oinfo.tradeNo }}</el-link></span
													>
												</div>

												<el-link style="height: 44px" type="danger" @click="handleDet(oinfo.tradeNo)">查看详情</el-link>
											</div>
										</td>
									</tr>
									<tr v-for="(ginfo, gidx) in oinfo.tradeOrderDetails" :key="gidx" class="tr-bd">
										<td>
											<div class="flexCenter" style="justify-content: start">
												<div class="goods-item">
													<div class="g-title">{{ ginfo.spuName }}{{ ginfo.skuName }}</div>
												</div>
												<!-- <div class="goods-number">{{ ginfo.salePrice }}元</div> -->
											</div>
										</td>
										<td v-if="gidx == 0" :rowspan="oinfo.tradeOrderDetails.length" class="tc">
											<div class="amount">
												<span style="display: inline-block; padding-bottom: 3px">{{ oinfo.totalAmount }}元</span>
												<!-- <br /> -->
												<!-- <span class="ftx-13">在线支付</span> -->
												<div v-if="oinfo.payType !== null && oinfo.tradeStatus != 4" class="logistics-info" style="margin-top: 10px">
													<p class="logistics-no">支付方式：{{ formatterPayType(oinfo.payType) }}</p>
													<!-- <el-link v-if="oinfo.payType === 2" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="showPayInfo(oinfo)">查看凭证</el-link> -->
													<el-link v-if="oinfo.payStatus === 3" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="showRemark(oinfo)">查看审核原因</el-link>
												</div>
											</div>
										</td>
										<td v-if="gidx == 0" :rowspan="oinfo.tradeOrderDetails.length" class="tc">
											<div v-if="oinfo.tradeStatus > 0 && oinfo.tradeStatus != 4">
												<span style="display: block">{{ formatterInvoiceStatus(oinfo.invoiceStatus) }}</span>
												<el-link v-if="oinfo.invoiceStatus === 0" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="handleInvoice(oinfo.tradeNo)"
													>查看开票信息</el-link
												>
												<el-link v-if="oinfo.invoiceStatus !== 0 && oinfo.invoiceStatus !== 1" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="handleApplyInvoice(oinfo.tradeNo)"
													>申请开票</el-link
												>
												<el-link v-if="oinfo.invoiceStatus === 1" style="margin-bottom: 4px; padding-right: 0; font-size: 12px" type="primary" @click="handleDownloadInvoice(oinfo.invoiceInfo)"
													>下载发票</el-link
												>
												<div v-if="oinfo.invoiceStatus === 1" class="logistics-info">
													<p class="logistics-no">更换发票请与客服联系</p>
												</div>
											</div>
										</td>
										<td v-if="gidx == 0" :rowspan="oinfo.tradeOrderDetails.length" class="tc">
											<div class="amount">
												<span>{{ formatterStatus(oinfo.tradeStatus) }}</span>
											</div>
										</td>
										<td v-if="gidx == 0" :rowspan="oinfo.tradeOrderDetails.length" class="tc">
											<div v-if="oinfo.tradeStatus == 0">
												<el-link style="margin-bottom: 4px" type="primary" @click="showPayModal(oinfo.tradeNo, oinfo.payType)">去付款</el-link>
												<br />
												<el-link v-if="oinfo.payStatus != 1" style="margin-bottom: 4px" type="primary" @click="showPayModalChange(oinfo.tradeNo, oinfo.totalAmount)"
													>更换支付方式</el-link
												>
												<br />
												<el-link style="margin-bottom: 4px" type="primary" @click="handleCancel(oinfo.tradeNo, oinfo.totalAmount)">取消订单</el-link>
											</div>
											<!-- <div v-if="oinfo.tradeStatus == 3">
												<el-link style="margin-bottom: 4px" type="primary" @click="handleInvoice(oinfo.tradeNo)">申请开票</el-link>
											</div> -->
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="pagebox" style="margin-top: 16px">
							<el-pagination :page-size="searchParams.pageSize" :total="totalNum" background layout="total, prev, pager, next" @current-change="handlePageChange"> </el-pagination>
						</div>
					</div>
					<div v-if="orderList.length == 0" class="emptybox">
						<el-empty description="没有此状态下的订单"></el-empty>
					</div>
				</div>
			</div>
		</div>
		<DialogShowPayInfo ref="DialogShowPayInfoRef" :corporateInfoUrl="corporateInfoUrl"></DialogShowPayInfo>
		<Pay ref="PayRef" :tradeComment="tradeComment" :orderNum="orderNum" :total="total" @successPay="successPay"></Pay>
		<!-- 发票信息 -->
		<DialogInvoiceInfo ref="dialogInvoiceInfo" :form="invoiceForm"></DialogInvoiceInfo>
		<!-- 申请开票 -->
		<DialogApplyInvoice ref="dialogApplyInvoice" :tradeNo="curOrderNo" @confirm="getOrderVipList"></DialogApplyInvoice>
		<!-- 更换支付方式 -->
		<DialogChangePayType ref="dialogChangePayType" :noOfflineTransfer="false" @changePayType="changePayType" :tradeNo="curOrderNo"></DialogChangePayType>
	</el-main>
</template>

<script>
import Y from '@/utils/Y';
import { getOrderVipList } from '@/api/vip/vip.js';
import { postConsumerOrderList, getConsumerOrderInfo, getConsumerOrderInvoice, getConsumerOrderCancel, getConsumerOrderReceipt, getConsumerOrderQueryStandard } from '@/api/order/order.js';
import Pay from '@/components/Pay/index.vue';
import moment from 'moment';
import TLoading from '@/utils/TLoading.js';
import User from '@/utils/User.js';
import TMessage from '@/utils/TMessage.js';
import DialogShowPayInfo from '@/views/UserCenter/components/DialogShowPayInfo.vue';
import DialogInvoiceInfo from '@/views/UserCenter/components/DialogInvoiceInfo.vue';
import DialogApplyInvoice from '@/views/UserCenter/components/DialogApplyInvoice.vue';
import DialogChangePayType from '@/views/UserCenter/components/DialogChangePayType.vue';
export default {
	data() {
		return {
			corporateInfoUrl: '',
			invoiceInfoUrl: '',

			invoiceForm: {},

			curOrderNo: '',

			loading: false,
			dataVal: [],
			pickerOptions: {
				shortcuts: [
					{
						text: ''
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},
			searchParams: {
				tradeNo: '',
				tradeStatus: [],
				payStatus: [],
				queryBegin: '',
				queryEnd: '',
				pageSize: 10,
				pageNum: 1
			},
			tradeStatusList: [
				{ label: '全部订单', value: '' },
				{ label: '待支付', value: 0 },
				{ label: '已支付', value: 1 },
				{ label: '已发货', value: 2 },
				{ label: '已完成', value: 3 },
				{ label: '已取消', value: 4 },
				{ label: '退款中', value: 5 },
				{ label: '已退款', value: 6 }
			],

			// 主要订单状态（默认显示）
			mainTradeStatusList: [
				{ label: '全部订单', value: '' },
				{ label: '待支付', value: 0 },
				{ label: '已完成', value: 3 },
				// { label: '已取消', value: 4 }
			],
			showMoreStatus: false,
			orderList: [],
			totalNum: 0,
			activeStatus: '',

			orderNum: null,
			total: null,
			tradeComment: null,

			curTradeNo: '',
			curGoods: []
		};
	},
	components: {
		Pay,
		DialogShowPayInfo,
		DialogInvoiceInfo,
		DialogApplyInvoice,
		DialogChangePayType
	},
	methods: {
		changePayType(val) {
			const { tradeNo, payType } = val;
			getConsumerOrderInfo(tradeNo).then(res => {
				if (res.code == 200) {
					//查询订单状态
					if (res.data.orderBasic.tradeStatus == 0) {
						const productName = res.data.orderDetails[0].skuName;
						if (payType == 0) {
							this.$router.push({ path: '/WeChatPay', query: { orderId: tradeNo, productName } });
						} else if (payType == 1) {
							this.$router.push({ path: '/AlipayPay', query: { orderId: tradeNo, productName } });
						} 
					} else {
						TMessage.warning('订单已支付或已取消');
					}
				}
			});
		},
		handleApplyInvoice(tradeNo) {
			this.curOrderNo = tradeNo;
			this.$refs.dialogApplyInvoice.dialogVisible = true;
		},
		formatterInvoiceStatus(invoiceStatus) {
			return invoiceStatus === 0 ? '开票中' : invoiceStatus === 1 ? '已开票' : '未开票';
		},
		async handleDownloadInvoice(invoiceInfo) {
			try {
				const response = await fetch(`/webL_api/third/files/info/${invoiceInfo}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				const imageUrlData = URL.createObjectURL(blob);
				this.invoiceInfoUrl = imageUrlData;
				this.downloadInvoice(this.invoiceInfoUrl);
			} catch (error) {
				console.error('获取图片失败:', error);
				return null;
			}
		},
		downloadInvoice(invoiceInfoUrl) {
			var image = new Image();
			image.setAttribute('crossOrigin', 'anonymous');
			var _this = this;
			image.onload = function () {
				var canvas = document.createElement('canvas');
				canvas.width = image.width;
				canvas.height = image.height;
				var context = canvas.getContext('2d');
				context.drawImage(image, 0, 0, image.width, image.height);
				var url = canvas.toDataURL('image/png'); //得到图片的base64编码数据
				var a = document.createElement('a'); // 生成一个a元素
				var event = new MouseEvent('click'); // 创建一个单击事件
				a.download = _this.projectName || 'photo'; // 设置图片名称
				a.href = url; // 将生成的URL设置为a.href属性
				a.dispatchEvent(event); // 触发a的单击事件
			};
			image.src = invoiceInfoUrl;
			this.$message.success('发票下载成功');
		},
		handleInvoice(tradeNo) {
			getConsumerOrderInvoice(tradeNo).then(res => {
				if (res.code === 200) {
					this.$refs.dialogInvoiceInfo.dialogVisible = true;
					this.invoiceForm = res.data;
					// this.corporateInfoUrl = res.data;
					// this.$refs.invoiceDialog.show();
				}
			});
		},

		async showPayInfo(info) {
			try {
				const response = await fetch(`/webL_api/third/files/info/${info.paymentVoucher}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				const imageUrlData = URL.createObjectURL(blob);
				this.corporateInfoUrl = imageUrlData;
				this.$refs.DialogShowPayInfoRef.dialogVisible = true;
			} catch (error) {
				console.error('获取图片失败:', error);
				return null;
			}
		},

		handleMoreStatusChange(visible) {
			this.showMoreStatus = visible;
		},

		formatterPayType(payType) {
			if (payType === null) {
				return '';
			} else {
				return payType == 0 ? '微信支付' : payType == 1 ? '支付宝支付' : '对公转账';
			}
		},

		// 支付成功后刷新订单列表
		successPay() {
			this.getOrderVipList();
		},

		handlePageChange(pageNum) {
			this.searchParams.pageNum = pageNum;
			window.scrollTo(0, 0);
			this.getOrderVipList();
		},

		gotoDetail(orderNo) {
			this.$router.push({ path: '/OrderDetail', query: { orderId: orderNo } });
		},

		handleDateChange(value) {
			if (this.dataVal == null) {
				this.searchParams.queryBegin = '';
				this.searchParams.queryEnd = '';
			} else {
				if (this.dataVal[0]) {
					this.searchParams.queryBegin = moment(this.dataVal[0]).format('YYYY-MM-DD');
				}
				if (this.dataVal[1]) {
					this.searchParams.queryEnd = moment(this.dataVal[1]).format('YYYY-MM-DD');
				}
			}
			this.getOrderVipList();
		},

		showPayModal(tradeNo, payType) {
			getConsumerOrderInfo(tradeNo).then(res => {
				if (res.code == 200) {
					//查询订单状态
					if (res.data.orderBasic.tradeStatus == 0) {
						const productName = res.data.orderDetails[0].skuName;
						if (payType == 0) {
							this.$router.push({ path: '/WeChatPay', query: { orderId: tradeNo, productName } });
						} else if (payType == 1) {
							this.$router.push({ path: '/AlipayPay', query: { orderId: tradeNo, productName } });
						} 
					} else {
						TMessage.warning('订单已支付或已取消');
					}
				}
			});
		},

		showPayModalChange(tradeNo, totalAmount) {
			this.curOrderNo = tradeNo;
			this.$refs.dialogChangePayType.dialogVisible = true;
			return;
			getConsumerOrderInfo(tradeNo).then(res => {
				if (res.code == 200) {
					//查询订单状态
					if (res.data.orderBasic.tradeStatus == 0) {
						//修改订单支付方式
						this.orderNum = tradeNo;
						this.total =totalAmount.toFixed(2);
						this.tradeComment = res.data.orderBasic.tradeComment;
						this.$refs.PayRef.payModal = true;
					} else {
						TMessage.warning('订单已支付或已取消');
					}
				}
			});
		},

		handleSearch() {
			this.searchParams.pageNum = 1;
			this.getOrderVipList();
		},

		async getOrderVipList() {
			this.loading = true;
			await getOrderVipList(this.searchParams)
				.then(res => {
					this.orderList = res.data.rows;
					this.totalNum = res.data.totalNum;
				})
				.catch(err => {
					Y.msg.error(err.message || '获取订单列表失败');
				})
				.finally(() => {
					this.loading = false;
				});
		},

		handleStatus(item) {
			this.activeStatus = item;
			if (this.activeStatus === '') {
				this.searchParams.tradeStatus = [];
			} else {
				this.searchParams.tradeStatus = [this.activeStatus];
			}
			this.getOrderVipList();
		},

		formatterStatus(status) {
			let statusText = '';
			switch (status) {
				case 0:
					statusText = '待支付';
					break;
				case 1:
					statusText = '已支付';
					break;
				case 2:
					statusText = '已发货';
					break;
				case 3:
					statusText = '已完成';
					break;
				case 4:
					statusText = '已取消';
					break;
				case 5:
					statusText = '退款中';
					break;
				case 6:
					statusText = '已退款';
					break;
				default:
					statusText = '未知状态';
			}
			return statusText;
		},

		//取消订单
		handleCancel(tradeNo) {
			Y.confirm('确认取消此订单吗？').then(rlt => {
				if (rlt.confirm) {
					this.getConsumerOrderCancel(tradeNo);
				}
			});
		},

		//取消订单
		async getConsumerOrderCancel(tradeNo) {
			await getConsumerOrderCancel(tradeNo)
				.then(res => {
					Y.msg.success('订单取消成功！');
					this.getOrderVipList();
				})
				.catch(err => {
					Y.msg.error(err.message || '订单取消失败');
				});
		},

		//查看详情
		handleDet(tradeNo) {
			this.goto({ path: '/OrderDet', query: { orderId: tradeNo } });
		}
	},

	// 加载完执行
	created() {
		if (this.$route.query.orderNum) {
			this.searchParams.tradeNo = this.$route.query.orderNum;
		}
		this.getOrderVipList();
	}
};
</script>

<style lang="less" scoped>
.topbox {
	margin-bottom: 10px;
	.tabtit {
		margin: 20px 0 15px;
		font-size: 16px;
		color: #475569;
		.el-link {
			font-size: 16px;
			i {
				color: #155dfc;
			}
		}
		.el-link:after {
			content: '';
			padding-left: 20px;
			border-right: 1px solid #eaeaea;
		}
		.el-link:last-child::after {
			border-right: 1px solid transparent;
		}
	}
}
.el-link {
	display: inline-block;
	margin-left: 0;
	padding-right: 20px;
	color: #475569;
	i {
		color: #ec2b2d;
		font-style: normal;
	}
}
.el-link.el-link--primary {
	color: #155dfc;
}
.el-link:hover {
	color: #155dfc;
}
.el-link.is-underline:hover:after {
	border-bottom: none;
}
.sku {
	color: #94a3b8;
	font-size: 12px;
	margin: 0;
}
.address-box {
}
.order-tbl {
	width: 100%;
	border-collapse: collapse;
	.number-col {
		width: 40%;
	}
	.amount-col {
		width: 15%;
	}
	.operate-col {
		width: 15%;
	}
	.tbl-head {
		height: 40px;
		color: #475569;
		font-size: 14px;
		background-color: rgba(227, 238, 255, 0.5);
		th {
			font-weight: 400;
		}
	}
	.tbl-body {
		td {
			padding: 0 15px;
			border: 1px solid #d0e3f9;
		}
		.sep-row {
			height: 20px;
			td {
				border: 0;
			}
		}
		.tr-th {
			height: 40px;
			font-size: 14px;
			line-height: 40px;
			color: #888;
			background-color: #e3eeff;
			span {
				margin-right: 20px;
			}
			.el-link {
				padding-right: 0;
				font-size: 14px;
				//color: #333333;
				color: #ef4444;
			}
			.right {
				float: right;
				margin-right: 0;
			}
		}
		.tr-bd {
			td {
				padding: 15px;
			}
			.goods-item {
				float: left;
				width: 80%;
				margin-right: 40px;
			}
			.g-atcs {
				margin-top: 12px;
			}
			.g-title {
				margin-bottom: 8px;
			}
			.g-stitle {
				margin-bottom: 20px;
				font-size: 12px;
				color: #888888;
			}
			.number {
				margin-right: 30px;
			}
			em {
				font-weight: bold;
				font-style: normal;
			}
			.ftx-13 {
				font-size: 12px;
				color: #888888;
				border-top: 1px solid #888888;
				padding-top: 5px;
				display: inline-block;
			}
		}
	}
}

.logistics-info {
	p {
		font-size: 12px;
		color: #888888;
	}
	.logistics-name {
		margin-bottom: 2px;
		border-bottom: 1px dashed #e2e8f0;
		display: inline-block;
		padding-bottom: 3px;
	}
	.logistics-no {
		margin-top: 0px;
	}
}

//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.orderwrap {
		width: 720px;
	}
	.topbox {
		.tabtit {
			.el-link {
				padding-right: 15px;
				font-size: 14px;
			}
		}
	}
	/deep/ .el-pagination {
		> span {
			display: none;
		}
	}
}

/deep/ .el-dropdown-menu__item.is-active {
	color: #155dfc;
	background-color: #ecf5ff;
}

.el-dropdown {
	margin-left: 0;
	padding-right: 20px;
}

	.card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 24px;
		padding-bottom: 20px;
		border-bottom: 1px dashed #e2e8f0;
	}
	.card-title {
		font-size: 18px;
		font-weight: 700;
		color: #0f172a;
		margin-bottom: 4px;
	}
	.card-desc {
		font-size: 13px;
		color: #94a3b8;
		line-height: 1.6;
	}
</style>
